<div class="object-view-and-edit-procedure">
  <div class="object-view-and-edit-procedure__top-headline">
    <h1>
      <i class="object-view-and-edit-procedure__headline-icon icon-procedure2"></i>

      @if (operationContainer.rootSectionsContainer.objectView) {
        <span class="object-view-and-edit-procedure__headline">
          {{operationContainer.rootSectionsContainer.objectView.artifact_name}}
        </span>
      }
    </h1>

    <div class="object-view-and-edit-procedure__button-container">
      @for (operation of operationContainer?.operations; track $index) {
        <ng-container>
          @if (operation.hide_menu_bar) {
            <button
              (click)="openOperation(operation)"
              class="object-view-and-edit-procedure__button"
              mat-stroked-button
              color="primary"
              type="button"
              [disabled]="isEditing"
              [hidden]="isEditing"
            >
              <i class="{{operation.menu_icon}}"></i>

              <span>&nbsp;</span>

              <span class="bold uppercase">
                {{ operation.menu_title | translate }}
              </span>
            </button>
          }
        </ng-container>
      }
    </div>
  </div>

  @if (!isEditing) {
   <div class="object-view-and-edit-procedure__overview">
     @for (field of fields; track $index) {
       <div class="object-view-and-edit-procedure__field">
         <div class="object-view-and-edit-procedure__field-title bold">
           <span>
             {{field.title}}:
           </span>
         </div>

         <div class="object-view-and-edit-procedure__field-content">
           @if (field.items) {
             <div>
               @for (item of field.items; track $index) {
                 <div
                   class="object-view-and-edit-procedure__field-items"
                   [ngClass]="{'level-1': item.header_values && item.header_values.level === 1,
                               'level-2': item.header_values && item.header_values.level === 2,
                               'new-array-item': item.is_new_array_item}"
                 >
                   @if (item.header_values) {
                     <div
                       class="item-header"
                       [ngClass]="{'bold': item.header_values.level === 1}"
                     >
                       <app-object-view-field-values
                         [fieldValues]="item.header_values"
                       ></app-object-view-field-values>
                     </div>
                   }

                   @if (item.field_values) {
                     <app-object-view-field-values
                       class="object-view-and-edit-procedure__field-items-value"
                       [stylingClass]="'display-title-and-content-inline'"
                       [fieldValues]="item.field_values"
                     ></app-object-view-field-values>
                   }
                 </div>
               }
             </div>
           }
         </div>
       </div>
     }
    </div>

    <app-object-view
      class="object-view-and-edit-procedure__view"
      [objectId]="operationContainer?.rootSectionsContainer.rootObject.artifact_id"
      [sectionsContainer]="operationContainer?.rootSectionsContainer"
      [templateGroupId]="operationContainer?.rootSectionsContainer.templateGroupId"
    ></app-object-view>
  }
  @else {
    <div class="object-view-and-edit-procedure__edit">
      @if (operationContainer?.rootSectionsContainer) {
        <app-object-edit
          [sectionsContainer]="operationContainer.rootSectionsContainer"
        ></app-object-edit>
      }
    </div>
  }
</div>
